###
  CRUD Campaign template
###

class INTENT.templates.CrudCampaign

  @get_result_container: (result_test, alert_text = '', url = '') ->
    small = ''
    if alert_text.length > 0
      small = """
              <p class="bg-warning fs xs">#{alert_text}</p>
              """

    if url.length > 0
      url = "<p>#{url}</p>"

    return """
      <p>#{result_test}</p>
      #{small}
      #{url}
    """

  @get_alert_container: (alert_text, type = "warning") ->
    """
    <p class="bg-#{type}">#{alert_text}</p>
    """

  @get_text_container: (alert_text, type = "info") ->
    """
    <p class="text-#{type}">#{alert_text}</p>
    """

  @get_group_warning_overhead: (alert_text) ->
    """
    <p class="bg-warning fs l">#{alert_text}</p>
    """
